import AppPageLayoutDesiger from 'modules/modeling/page/AppPageLayoutDesiger/AppPageLayoutDesiger'
import React from 'react'

export const PageLayoutDesiger = () => {
	return <AppPageLayoutDesiger />
}



// WEBPACK FOOTER //
// ./src/modules/modeling/page/PageLayoutDesiger.tsx